// extracted by mini-css-extract-plugin
export default {"input-url-container":"styles_input-url-container__ATGJG","input-url":"styles_input-url__Yobi+","upload-button":"styles_upload-button__ZUu-Z"};